import React from 'react';

export const Dumbbell = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="none"
  >
    <rect
      x="97.3262"
      y="391.443"
      width="418.422"
      height="42.1379"
      rx="14"
      transform="rotate(-45 97.3262 391.443)"
      fill="url(#paint0_linear_2106_433)"
    />
    <rect
      x="97.3262"
      y="391.443"
      width="418.422"
      height="42.1379"
      rx="14"
      transform="rotate(-45 97.3262 391.443)"
      fill="url(#paint1_radial_2106_433)"
      fillOpacity="0.6"
    />
    <rect
      x="97.3262"
      y="391.443"
      width="418.422"
      height="42.1379"
      rx="14"
      transform="rotate(-45 97.3262 391.443)"
      fill="url(#paint2_radial_2106_433)"
      fillOpacity="0.6"
    />
    <rect
      x="97.3262"
      y="391.443"
      width="418.422"
      height="42.1379"
      rx="14"
      transform="rotate(-45 97.3262 391.443)"
      fill="url(#paint3_radial_2106_433)"
      fillOpacity="0.6"
    />
    <path
      d="M379.645 129.887C381.163 129.887 382.395 128.656 382.395 127.137C382.395 125.618 381.163 124.387 379.645 124.387C378.126 124.387 376.895 125.618 376.895 127.137C376.895 128.656 378.126 129.887 379.645 129.887Z"
      fill="#AC76FF"
    />
    <path
      d="M235.395 275.137C236.499 275.137 237.395 274.241 237.395 273.137C237.395 272.032 236.499 271.137 235.395 271.137C234.29 271.137 233.395 272.032 233.395 273.137C233.395 274.241 234.29 275.137 235.395 275.137Z"
      fill="#AC76FF"
    />
    <path
      d="M293.145 247.887C294.249 247.887 295.145 246.991 295.145 245.887C295.145 244.782 294.249 243.887 293.145 243.887C292.04 243.887 291.145 244.782 291.145 245.887C291.145 246.991 292.04 247.887 293.145 247.887Z"
      fill="#AC76FF"
    />
    <path
      d="M122.395 386.637C123.499 386.637 124.395 385.741 124.395 384.637C124.395 383.532 123.499 382.637 122.395 382.637C121.29 382.637 120.395 383.532 120.395 384.637C120.395 385.741 121.29 386.637 122.395 386.637Z"
      fill="#AC76FF"
    />
    <rect
      x="76.916"
      y="311.028"
      width="49.4975"
      height="184.726"
      rx="22"
      transform="rotate(-45 76.916 311.028)"
      fill="url(#paint4_radial_2106_433)"
    />
    <rect
      x="76.916"
      y="311.028"
      width="49.4975"
      height="184.726"
      rx="22"
      transform="rotate(-45 76.916 311.028)"
      fill="url(#paint5_linear_2106_433)"
    />
    <rect
      x="76.916"
      y="311.028"
      width="49.4975"
      height="184.726"
      rx="22"
      transform="rotate(-45 76.916 311.028)"
      fill="url(#paint6_linear_2106_433)"
      fillOpacity="0.7"
    />
    <rect
      x="76.916"
      y="311.028"
      width="49.4975"
      height="184.726"
      rx="22"
      transform="rotate(-45 76.916 311.028)"
      fill="url(#paint7_radial_2106_433)"
      fillOpacity="0.6"
    />
    <rect
      x="76.916"
      y="311.028"
      width="49.4975"
      height="184.726"
      rx="22"
      transform="rotate(-45 76.916 311.028)"
      fill="url(#paint8_radial_2106_433)"
      fillOpacity="0.6"
    />
    <rect
      x="273.984"
      y="113.959"
      width="49.4975"
      height="184.726"
      rx="22"
      transform="rotate(-45 273.984 113.959)"
      fill="url(#paint9_radial_2106_433)"
    />
    <rect
      x="273.984"
      y="113.959"
      width="49.4975"
      height="184.726"
      rx="22"
      transform="rotate(-45 273.984 113.959)"
      fill="url(#paint10_linear_2106_433)"
    />
    <rect
      x="273.984"
      y="113.959"
      width="49.4975"
      height="184.726"
      rx="22"
      transform="rotate(-45 273.984 113.959)"
      fill="url(#paint11_radial_2106_433)"
      fillOpacity="0.8"
    />
    <rect
      x="273.984"
      y="113.959"
      width="49.4975"
      height="184.726"
      rx="22"
      transform="rotate(-45 273.984 113.959)"
      fill="url(#paint12_radial_2106_433)"
      fillOpacity="0.6"
    />
    <rect
      x="91.5977"
      y="255.709"
      width="49.4975"
      height="242.196"
      rx="22"
      transform="rotate(-45 91.5977 255.709)"
      fill="url(#paint13_radial_2106_433)"
    />
    <rect
      x="91.5977"
      y="255.709"
      width="49.4975"
      height="242.196"
      rx="22"
      transform="rotate(-45 91.5977 255.709)"
      fill="url(#paint14_radial_2106_433)"
    />
    <rect
      x="91.5977"
      y="255.709"
      width="49.4975"
      height="242.196"
      rx="22"
      transform="rotate(-45 91.5977 255.709)"
      fill="url(#paint15_linear_2106_433)"
    />
    <rect
      x="91.5977"
      y="255.709"
      width="49.4975"
      height="242.196"
      rx="22"
      transform="rotate(-45 91.5977 255.709)"
      fill="url(#paint16_radial_2106_433)"
      fillOpacity="0.8"
    />
    <rect
      x="91.5977"
      y="255.709"
      width="49.4975"
      height="242.196"
      rx="22"
      transform="rotate(-45 91.5977 255.709)"
      fill="url(#paint17_radial_2106_433)"
      fillOpacity="0.6"
    />
    <path
      d="M199.931 309.079C200.593 309.079 201.129 308.543 201.129 307.881C201.129 307.219 200.593 306.683 199.931 306.683C199.27 306.683 198.733 307.219 198.733 307.881C198.733 308.543 199.27 309.079 199.931 309.079Z"
      fill="#C2F370"
    />
    <path
      d="M191.021 293.299C191.021 293.96 190.485 294.497 189.823 294.497C189.162 294.497 188.626 293.96 188.626 293.299C188.626 292.637 189.162 292.101 189.823 292.101C190.485 292.101 191.021 292.637 191.021 293.299Z"
      fill="#C2F370"
    />
    <path
      d="M169.461 301.13C170.784 301.13 171.856 300.058 171.856 298.735C171.856 297.412 170.784 296.339 169.461 296.339C168.138 296.339 167.065 297.412 167.065 298.735C167.065 300.058 168.138 301.13 169.461 301.13Z"
      fill="#C2F370"
    />
    <path
      d="M243.277 363.734C244.6 363.734 245.672 362.662 245.672 361.339C245.672 360.016 244.6 358.943 243.277 358.943C241.953 358.943 240.881 360.016 240.881 361.339C240.881 362.662 241.953 363.734 243.277 363.734Z"
      fill="#C2F370"
    />
    <path
      d="M261.369 373.661C261.369 374.612 260.599 375.383 259.648 375.383C258.697 375.383 257.926 374.612 257.926 373.661C257.926 372.711 258.697 371.94 259.648 371.94C260.599 371.94 261.369 372.711 261.369 373.661Z"
      fill="#C2F370"
    />
    <path
      d="M250.932 357.836C251.883 357.836 252.654 357.065 252.654 356.114C252.654 355.163 251.883 354.392 250.932 354.392C249.981 354.392 249.21 355.163 249.21 356.114C249.21 357.065 249.981 357.836 250.932 357.836Z"
      fill="#C2F370"
    />
    <path
      d="M257.926 366.91C257.926 367.572 257.389 368.108 256.728 368.108C256.066 368.108 255.53 367.572 255.53 366.91C255.53 366.249 256.066 365.712 256.728 365.712C257.389 365.712 257.926 366.249 257.926 366.91Z"
      fill="#C2F370"
    />
    <path
      d="M177.278 335.57C177.94 335.57 178.476 335.034 178.476 334.372C178.476 333.711 177.94 333.174 177.278 333.174C176.617 333.174 176.081 333.711 176.081 334.372C176.081 335.034 176.617 335.57 177.278 335.57Z"
      fill="#C2F370"
    />
    <path
      d="M129.282 269.802C129.282 270.463 128.746 270.999 128.085 270.999C127.423 270.999 126.887 270.463 126.887 269.802C126.887 269.14 127.423 268.604 128.085 268.604C128.746 268.604 129.282 269.14 129.282 269.802Z"
      fill="#C2F370"
    />
    <path
      d="M130.48 260.791C131.803 260.791 132.875 259.719 132.875 258.396C132.875 257.073 131.803 256 130.48 256C129.157 256 128.084 257.073 128.084 258.396C128.084 259.719 129.157 260.791 130.48 260.791Z"
      fill="#C2F370"
    />
    <path
      d="M142.185 275.099C142.185 275.76 141.649 276.296 140.988 276.296C140.326 276.296 139.79 275.76 139.79 275.099C139.79 274.437 140.326 273.901 140.988 273.901C141.649 273.901 142.185 274.437 142.185 275.099Z"
      fill="#C2F370"
    />
    <path
      d="M192.355 342.089C193.016 342.089 193.553 341.553 193.553 340.892C193.553 340.23 193.016 339.694 192.355 339.694C191.693 339.694 191.157 340.23 191.157 340.892C191.157 341.553 191.693 342.089 192.355 342.089Z"
      fill="#C2F370"
    />
    <path
      d="M270.045 392.887C270.707 392.887 271.243 392.351 271.243 391.689C271.243 391.028 270.707 390.491 270.045 390.491C269.384 390.491 268.848 391.028 268.848 391.689C268.848 392.351 269.384 392.887 270.045 392.887Z"
      fill="#C2F370"
    />
    <rect
      x="218.666"
      y="128.64"
      width="49.4975"
      height="242.196"
      rx="22"
      transform="rotate(-45 218.666 128.64)"
      fill="url(#paint18_radial_2106_433)"
    />
    <rect
      x="218.666"
      y="128.64"
      width="49.4975"
      height="242.196"
      rx="22"
      transform="rotate(-45 218.666 128.64)"
      fill="url(#paint19_linear_2106_433)"
    />
    <rect
      x="218.666"
      y="128.64"
      width="49.4975"
      height="242.196"
      rx="22"
      transform="rotate(-45 218.666 128.64)"
      fill="url(#paint20_radial_2106_433)"
      fillOpacity="0.8"
    />
    <rect
      x="218.666"
      y="128.64"
      width="49.4975"
      height="242.196"
      rx="22"
      transform="rotate(-45 218.666 128.64)"
      fill="url(#paint21_radial_2106_433)"
      fillOpacity="0.6"
    />
    <path
      d="M287.941 184.998C289.264 184.998 290.337 183.925 290.337 182.602C290.337 181.279 289.264 180.207 287.941 180.207C286.618 180.207 285.546 181.279 285.546 182.602C285.546 183.925 286.618 184.998 287.941 184.998Z"
      fill="#FF9A01"
    />
    <path
      d="M332.257 226.06C333.58 226.06 334.653 224.988 334.653 223.664C334.653 222.341 333.58 221.269 332.257 221.269C330.934 221.269 329.861 222.341 329.861 223.664C329.861 224.988 330.934 226.06 332.257 226.06Z"
      fill="#FF9A01"
    />
    <path
      d="M363.1 226.06C363.1 227.011 362.329 227.782 361.378 227.782C360.427 227.782 359.656 227.011 359.656 226.06C359.656 225.109 360.427 224.338 361.378 224.338C362.329 224.338 363.1 225.109 363.1 226.06Z"
      fill="#FF9A01"
    />
    <path
      d="M339.912 220.162C340.863 220.162 341.634 219.391 341.634 218.44C341.634 217.489 340.863 216.718 339.912 216.718C338.961 216.718 338.19 217.489 338.19 218.44C338.19 219.391 338.961 220.162 339.912 220.162Z"
      fill="#FF9A01"
    />
    <path
      d="M366.906 238.611C366.906 239.272 366.37 239.809 365.708 239.809C365.047 239.809 364.511 239.272 364.511 238.611C364.511 237.949 365.047 237.413 365.708 237.413C366.37 237.413 366.906 237.949 366.906 238.611Z"
      fill="#FF9A01"
    />
    <path
      d="M252.013 142.127C252.013 142.789 251.476 143.325 250.815 143.325C250.153 143.325 249.617 142.789 249.617 142.127C249.617 141.466 250.153 140.929 250.815 140.929C251.476 140.929 252.013 141.466 252.013 142.127Z"
      fill="#FF9A01"
    />
    <path
      d="M253.21 133.117C254.533 133.117 255.606 132.044 255.606 130.721C255.606 129.398 254.533 128.326 253.21 128.326C251.887 128.326 250.815 129.398 250.815 130.721C250.815 132.044 251.887 133.117 253.21 133.117Z"
      fill="#FF9A01"
    />
    <path
      d="M264.916 147.424C264.916 148.086 264.38 148.622 263.718 148.622C263.057 148.622 262.52 148.086 262.52 147.424C262.52 146.763 263.057 146.227 263.718 146.227C264.38 146.227 264.916 146.763 264.916 147.424Z"
      fill="#FF9A01"
    />
    <path
      d="M297.613 186.196C298.275 186.196 298.811 185.659 298.811 184.998C298.811 184.336 298.275 183.8 297.613 183.8C296.952 183.8 296.416 184.336 296.416 184.998C296.416 185.659 296.952 186.196 297.613 186.196Z"
      fill="#FF9A01"
    />
    <path
      d="M392.776 265.213C393.437 265.213 393.974 264.676 393.974 264.015C393.974 263.353 393.437 262.817 392.776 262.817C392.114 262.817 391.578 263.353 391.578 264.015C391.578 264.676 392.114 265.213 392.776 265.213Z"
      fill="#FF9A01"
    />
    <path
      d="M307.25 138.887C308.769 138.887 310 137.656 310 136.137C310 134.618 308.769 133.387 307.25 133.387C305.731 133.387 304.5 134.618 304.5 136.137C304.5 137.656 305.731 138.887 307.25 138.887Z"
      fill="#2EB0FA"
    />
    <path
      d="M343 142.887C344.105 142.887 345 141.992 345 140.887C345 139.782 344.105 138.887 343 138.887C341.895 138.887 341 139.782 341 140.887C341 141.992 341.895 142.887 343 142.887Z"
      fill="#2EB0FA"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2106_433"
        x1="437.601"
        y1="381.781"
        x2="433.123"
        y2="496.741"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.127989" stopColor="#E6D5D0" />
        <stop offset="0.473293" stopColor="#FCF1E8" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(516.392 392.086) rotate(77.8335) scale(69.0271 90.5887)"
      >
        <stop offset="0.344968" stopColor="#B9A69A" />
        <stop offset="0.559987" stopColor="#F3E6DF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(355.577 414.308) rotate(3.06218) scale(170.576 72.1617)"
      >
        <stop offset="0.344968" stopColor="#B9A69A" />
        <stop offset="0.559987" stopColor="#F3E6DF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(153.344 412.893) rotate(-4.76364) scale(102.176 66.3908)"
      >
        <stop offset="0.344968" stopColor="#B9A69A" />
        <stop offset="0.559987" stopColor="#F3E6DF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(90.6787 509.516) rotate(-87.5515) scale(310.535 203.853)"
      >
        <stop offset="0.267531" stopColor="#B4E159" />
        <stop offset="0.430746" stopColor="#50CAFE" />
      </radialGradient>
      <linearGradient
        id="paint5_linear_2106_433"
        x1="53.0334"
        y1="391.598"
        x2="118.878"
        y2="404.608"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.19048" stopColor="#0D83E4" />
        <stop offset="0.60295" stopColor="#52CBFF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2106_433"
        x1="100.41"
        y1="433.317"
        x2="23.8009"
        y2="447.183"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0489" stopColor="#B4E159" stopOpacity="0" />
        <stop offset="0.37284" stopColor="#79B52E" />
        <stop offset="0.801968" stopColor="#479126" />
      </linearGradient>
      <radialGradient
        id="paint7_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.9813 344.575) rotate(76.1106) scale(234.182 166.834)"
      >
        <stop offset="0.56531" stopColor="#70A800" stopOpacity="0" />
        <stop offset="0.713437" stopColor="#177001" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(107.127 361.546) rotate(88.1524) scale(54.8293 19.4274)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(241.519 164.83) rotate(61.4659) scale(211.681 390.936)"
      >
        <stop offset="0.167673" stopColor="#FFA0D4" />
        <stop offset="0.208194" stopColor="#EFBDFE" />
      </radialGradient>
      <linearGradient
        id="paint10_linear_2106_433"
        x1="260.628"
        y1="195.77"
        x2="320.726"
        y2="194.843"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0891231" stopColor="#A41468" />
        <stop offset="0.588502" stopColor="#FFA2D6" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint11_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(317.003 192.387) rotate(174.144) scale(191.726 505.381)"
      >
        <stop offset="0.115155" stopColor="#EFBEFE" stopOpacity="0" />
        <stop offset="0.252983" stopColor="#A162D5" />
        <stop offset="0.354167" stopColor="#8138BD" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(313.661 167.186) rotate(88.3059) scale(51.7099 9.81347)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint13_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(146.831 273.17) rotate(151.32) scale(231.32 485.721)"
      >
        <stop offset="0.167673" stopColor="#FFBF16" />
        <stop offset="0.253789" stopColor="#FF8D08" />
      </radialGradient>
      <radialGradient
        id="paint14_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(146.831 273.17) rotate(151.32) scale(231.32 485.721)"
      >
        <stop offset="0.167673" stopColor="#FFDD65" />
        <stop offset="0.253789" stopColor="#FF9900" />
      </radialGradient>
      <linearGradient
        id="paint15_linear_2106_433"
        x1="78.2413"
        y1="362.972"
        x2="138.345"
        y2="362.265"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B4432B" />
        <stop offset="0.438694" stopColor="#B4432B" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint16_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(134.617 358.537) rotate(172.341) scale(192.443 660.145)"
      >
        <stop offset="0.115155" stopColor="#FF8D08" stopOpacity="0" />
        <stop offset="0.252983" stopColor="#F24D18" />
        <stop offset="0.354167" stopColor="#A52800" />
      </radialGradient>
      <radialGradient
        id="paint17_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(131.274 325.496) rotate(88.7077) scale(67.785 9.81526)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint18_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(273.899 146.101) rotate(151.32) scale(231.32 485.721)"
      >
        <stop offset="0.167673" stopColor="#0095FF" />
        <stop offset="0.253789" stopColor="#4FCCFF" />
      </radialGradient>
      <linearGradient
        id="paint19_linear_2106_433"
        x1="205.31"
        y1="235.903"
        x2="265.414"
        y2="235.196"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0072C2" />
        <stop offset="0.438694" stopColor="#0072C2" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint20_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(261.685 231.468) rotate(172.341) scale(192.443 660.145)"
      >
        <stop offset="0.115155" stopColor="#50CCFF" stopOpacity="0" />
        <stop offset="0.252983" stopColor="#0178E6" />
        <stop offset="0.354167" stopColor="#0075E0" />
      </radialGradient>
      <radialGradient
        id="paint21_radial_2106_433"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(258.343 198.427) rotate(88.7077) scale(67.785 9.81526)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);
